package tta.destinigo.talktoastro.feature_expert_details.expert_detail_page.expert_details_state_info

sealed class SubmitExpertReviewState {
    data class Loading(val isLoading: Boolean): SubmitExpertReviewState()
    data class Success(val isSuccess: Boolean): SubmitExpertReviewState()
    data class Error(val msg: String): SubmitExpertReviewState()
}